var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsLive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "59mes75boa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368 0v1600H0V0h1368z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c9mg21y3tb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.667 21.333A5.333 5.333 0 0 1 30 30.83v22.297a26.923 26.923 0 0 1-3.323.206h-.02c-1.126 0-2.235-.07-3.324-.206V30.83a5.333 5.333 0 0 1 3.333-9.497zm0-21.333c14.727 0 26.666 11.94 26.666 26.667 0 12.184-8.171 22.46-19.333 25.645V45.28c7.418-2.924 12.667-10.155 12.667-18.612 0-11.046-8.955-20-20-20-11.046 0-20 8.954-20 20 0 8.457 5.249 15.688 12.666 18.612v7.033C8.172 49.127 0 38.851 0 26.667 0 11.939 11.94 0 26.667 0zm0 10.667c8.836 0 16 7.163 16 16 0 6.193-3.52 11.565-8.667 14.224v-8.45a9.294 9.294 0 0 0 2-5.774 9.333 9.333 0 1 0-18.667 0c0 2.18.748 4.185 2 5.774v8.45c-5.147-2.66-8.666-8.03-8.666-14.224 0-8.837 7.163-16 16-16z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59mes75boa)",
    transform: "translate(-1216 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9mg21y3tb)",
    transform: "translate(1221.333 341.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255, 255, 255, 1)",
    d: "M0 0h53.333v53.333H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLive);
export default __webpack_public_path__ + "static/media/icons-live.67f99c554a780c62d910d4a17d7022aa.svg";
export { ForwardRef as ReactComponent };